import { ITableColumn } from "components/interfaces";
import { lang } from "i18nLang";
import { copyJson } from "utils";

export const columnsAdditives: ITableColumn[] = [
  {
    dataKey: "structured",
    label: lang("indicatorsPage.addsAndCancels.structured"),
    width: 100,
  },
  {
    dataKey: "description",
    label: lang("indicatorsPage.addsAndCancels.description"),
    width: 250,
    truncateText: true,
  },
  {
    dataKey: "quantityApplied",
    label: lang("indicatorsPage.addsAndCancels.quantityApplied"),
    width: 130,
    numeric: true,
  },
  {
    dataKey: "totalApplied",
    label: lang("indicatorsPage.addsAndCancels.totalApplied"),
    width: 160,
    monetary: true,
  },
  {
    dataKey: "dateFormated",
    label: lang("indicatorsPage.addsAndCancels.date"),
    width: 100,
  },
  {
    dataKey: "userName",
    label: lang("indicatorsPage.addsAndCancels.userName"),
    truncateText: true,
  },
];

export const columnsCancellations: ITableColumn[] = copyJson(columnsAdditives);
columnsCancellations[2].label = lang(
  "indicatorsPage.addsAndCancels.quantityCanceled"
);

export const columnsOtherChanges: ITableColumn[] = [
  {
    dataKey: "structured",
    label: lang("indicatorsPage.addsAndCancels.structured"),
    width: 100,
  },
  {
    dataKey: "descriptionBefore",
    label: lang("indicatorsPage.addsAndCancels.descriptionBefore"),
    width: 130,
    truncateText: true,
  },
  {
    dataKey: "descriptionAfter",
    label: lang("indicatorsPage.addsAndCancels.descriptionAfter"),
    width: 130,
    truncateText: true,
  },
  {
    dataKey: "quantityBefore",
    label: lang("indicatorsPage.addsAndCancels.quantityBefore"),
    width: 120,
  },
  {
    dataKey: "quantityAfter",
    label: lang("indicatorsPage.addsAndCancels.quantityAfter"),
    width: 120,
  },
  {
    dataKey: "dateFormated",
    label: lang("indicatorsPage.addsAndCancels.date"),
    width: 100,
  },
  {
    dataKey: "userName",
    label: lang("indicatorsPage.addsAndCancels.userName"),
    truncateText: true,
  },
];
